import React from 'react';

import { BottomActionLayout } from '@/components/shared/BottomActionLayout/BottomActionLayout';
import { AsaphButton } from '@/components/shared/Button';
import { ModalSectionCard } from '@/components/shared/ModalSectionCard';
import { UpgradeGateSheet } from '@/components/shared/UpgradeGateSheet';
import {
	SettingsList,
	SettingsListItems,
} from '@/components/shared/SettingCard';
import { DAYS_OF_WEEK } from '@/config/constants';
import { Permissions } from '@/graphql';
import { hr24to12 } from '@/helpers/timeFormatter';
import { usePermissions } from '@/providers/PermissionsProvider';
import { useServices } from '@/providers/ServicesProvider';

import { AccountDisplayProps, EAccountDisplayState } from '../../AccountPanel';
import styles from './Services.module.scss';

export const Services: React.FC<AccountDisplayProps> = ({
	pushDisplayState,
	setCustomTitle,
	setService,
}) => {
	const { services } = useServices();
	const { hasPermission } = usePermissions();
	const [showServicesGate, setShowServicesGate] = React.useState(false);

	const serviceSettingItems: SettingsListItems = services.map((s) => ({
		type: 'setting',
		title: s.name,
		subtitle: `${DAYS_OF_WEEK[s.day]}, ${hr24to12(s.startAt)}`,
		onClick: () => {
			setService(s);
			setCustomTitle('Edit service');
			pushDisplayState(EAccountDisplayState.CREATE_UPDATE_SERVICE);
		},
		noChevron: !hasPermission(Permissions.ServiceUpdate),
		disabled: !hasPermission(Permissions.ServiceUpdate),
	}));

	return (
		<>
			<BottomActionLayout
				actionHidden={!hasPermission(Permissions.ServiceCreate)}
				contentClassName={styles['root']}
				actionContent={
					<div className={styles['action-stack']}>
						{services.length >= 1 && (
							<div className={styles['capacity-banner']}>
								{services.length} of 1 services on your current plan.
							</div>
						)}
						<AsaphButton
							color="blue"
							label="Create Service"
							onClick={() => {
								if (services.length >= 1) {
									setShowServicesGate(true);
								} else {
									pushDisplayState(
										EAccountDisplayState.CREATE_UPDATE_SERVICE,
									);
								}
							}}
							fullWidth
						/>
					</div>
				}
			>
				{!services.length ? (
					hasPermission(Permissions.ServiceCreate) ? (
						<ModalSectionCard
							className={styles['section-card']}
							paddingSize="lg"
						>
							No services. Create your first one now.
						</ModalSectionCard>
					) : (
						<ModalSectionCard
							className={styles['section-card']}
							paddingSize="lg"
						>
							No services. Ask an admin to create your first service.
						</ModalSectionCard>
					)
				) : null}
				<SettingsList
					className={styles['song-settings__upper-list']}
					items={serviceSettingItems}
					noChevron
				/>
			</BottomActionLayout>
			<UpgradeGateSheet
				open={showServicesGate}
				onClose={() => setShowServicesGate(false)}
				heading="Services"
				body="You've reached your 1 service limit. Continue to add another."
				gateName="services"
				onSkip={() => pushDisplayState(EAccountDisplayState.CREATE_UPDATE_SERVICE)}
				rememberAcceptance={true}
			/>
		</>
	);
};

export default Services;
